{
  "index": {
    "in_progress": "Here belongs data."
  },
  "search": "Search",
  "reset": "Reset filters",
  "main": {
    "title": "Welcome to admin dashboard",
    "subtitle": "Admin"
  },
  "tickets": {
    "title": "Tickets",
    "subtitle": "Dashboard - Changing step",
    "drag_and_drop": {
      "not_allowed": "You are not allowed to drag here."
    }
  },
  "sidebar": {
    "category": {
      "application": "Application"
    },
    "links": {
      "home": "Home",
      "dashboard": "Dashboard",
      "tickets": "Tickets",
      "users": "Users",
      "internal_signers": "Internal Signers",
      "contacts": "Contacts",
      "crm_users": "CRM user",
      "workflows": "Workflows",
      "packages": "Advantages packages",
      "operations": "Operations types",
      "identity": "Identity",
      "contract_templates": "Contract templates",
      "conventions": "Conventions",
      "email_reminders": "Automatic reminders",
      "attachments_templates": "Attachment(s)",
      "products": "Product(s)",
      "therapeutic_areas": "Therapeutic area(s)",
      "sectors": "Sector(s)",
      "units": "Sevice(s)",
      "regions": "Region(s)",
      "specialties": "Specialties",
      "settings": {
        "label": "Settings",
        "signatures": "Electronic signatures",
        "watchdogs": "Watchdogs",
        "upsell": "Upsell",
        "notifications": "Notifications",
        "permissions": "Permissions",
        "attendee_sources": "Search sources"
      },
      "signatures_settings": "Electronic signature",
      "simplified_declarations": "Simplified declarations",
      "declarations": "Simplified declarations",
      "allocation": {
        "label": "Allocations",
        "therapeutic_areas": "Therapeutic areas",
        "unit": "Unit",
        "sector": "Sector",
        "region": "Region",
        "product": "Product",
        "network": "Network",
        "uga": "UGA",
        "zone": "Zone",
        "identity": "Identity"
      },
      "management": {
        "label": "Management",
        "tickets": "Tickets",
        "users": "Users",
        "internal_signers": "Internal signers",
        "contacts": "Contacts",
        "workflows": "Workflows",
        "packages": "Advantages packs",
        "operations": "Operation types",
        "contract_templates": "Contract templates",
        "conventions": "Conventions",
        "attachments_templates": "Attachment templates",
        "specialties": "Specialties",
        "declarations": "Simplified declarations",
        "crm_users": "CRM referents"
      }
    }
  },
  "table": {
    "header": {
      "attachment_template": {
        "name": "File name",
        "type": "File type",
        "comment": "Comment"
      },
      "crm_user": {
        "firstname": "First name",
        "lastname": "Last name",
        "email": "Email",
        "responsibilities": "Role",
        "post_title": "Function",
        "staff_id": "Staff ID"
      },
      "user": {
        "first_name": "First name",
        "last_name": "Last name",
        "email": "Email",
        "phone_number": "Phone number",
        "enabled": "State"
      },
      "ticket": {
        "name": "Last name",
        "status": "Status",
        "step": "Step"
      },
      "internal_signer": {
        "firstname": "First name",
        "lastname": "Last name",
        "executive_role": "Function",
        "email": "Email",
        "phone_number": "Phone number",
        "civility": "Civility",
        "staff_id": "Staff ID"
      },
      "contact": {
        "name": "Last name",
        "details": "Details"
      },
      "contract_template": {
        "name": "Last name",
        "signature_request_type": "Signature request type"
      },
      "package": {
        "name": "Last name",
        "advantages": "Benefits",
        "email": "Email",
        "phone_number": "Phone number"
      },
      "workflow": {
        "name": "Last name",
        "steps": "Steps"
      },
      "notifications": {
        "name": "Last name",
        "notification_type": "Notification type",
        "event_type": "Event type",
        "operation_type": "Operation type",
        "criteria": "Criteria",
        "state": "State"
      },
      "common": {
        "actions": "Actions"
      }
    }
  },
  "common": {
    "cancel": "Cancel"
  },
  "package": {
    "tabs": {
      "planned": "Planned package",
      "actual": "Actual packages"
    },
    "title": {
      "create": "Create a package",
      "edit": "Edit a package"
    },
    "name": "Last name",
    "create": "Create a Package",
    "update": "Update a Package",
    "abort_update": "Abort update",
    "distribution_pack": "Distribution pack"
  },
  "operation": {
    "search_placeholder": "Search an operation type by name",
    "selected_entity": "operations",
    "list_title": {
      "all": "Operation types",
      "enabled": "Enabled operations",
      "disabled": "Disabled operations"
    },
    "title": {
      "create": "Create an operation type",
      "edit": "Edit an operation"
    },
    "tab": {
      "general_informations": "General information",
      "link": "Links"
    },
    "name": "Last name",
    "create": "Create an operation type",
    "update": "Operation update",
    "modal": {
      "title": "Update operation type",
      "text": "Do you wish to impact the existing tickets ? this modification is permanent",
      "clone": "update without impacting",
      "edit": "Validate"
    },
    "input": {
      "name": "Last name",
      "eventTypes": "Event types",
      "donation_type": "Donation type",
      "operation_type_transparency": "Health Transparency operation type",
      "operation_type_eps": "Operation type EPS",
      "operation_type_idahe": "Operation Type IDAHE",
      "donation_types": {
        "DONATION_AND_GENEROSITY_FOR_RESEARCH_ACTIVITIES": "donation and generosity for research activities",
        "DONATIONS_FOR_HEALTH_RELATED_ACTIVITIES": "donations for health related activities",
        "DONATION_FOR_PUBLIC_UTILITY": "donation for public utility"
      },
      "idahe_convention": "Convention IDAHE",
      "idahe_typology": "Typology IDAHE",
      "idahe_conventions": {
        "RESEARCH": "Conventions in the frame of research activities, valorization of research, scientific evaluation, consulting, service provision or commercial promotion",
        "MANIFESTATION": "Conventions in the frame of professional or scientific exclusive manifestations, manifestations for the promotion of products or services mentioned in article L. 1453-8 of the Public Health Code",
        "FINANCIAL": "Conventions aiming at funding or participating in the funding of professional training or continuous professional development actions"
      },
      "idahe_typologies": {
        "OTHER": "other",
        "AWARD_CONTRACT": "award contract",
        "CONGRESS_REGISTRATION_CONTRACT": "conference registration contract",
        "CONSULTING_NON_SCIENTIFIC_CONTRACT": "consulting or expertise contract other than scientific survey, study, market study",
        "EVENT_SPEAKER_CONTRACT": "event speaker contract",
        "EXPERT_SCIENTIFIC_CONTRACT": "expert scientific contract",
        "GRANT_AWARD_CONTRACT": "research grant award contract",
        "MARKET_STUDY": "survey, study, market study (outside research)",
        "PARTNERSHIP": "partnership",
        "PATRONAGE": "patronage",
        "PURCHASE_RENTAL_ADVERTISING_SPACE_CONTRACT": "purchase or rental advertising space contract",
        "PURCHASE_RENTAL_SCIENTIFIC_EVENT_SPACE_CONTRACT": "purchase or rental scientific event space contract",
        "RESEARCH_CONTRACT": "research contract",
        "SCIENTIFIC_EVALUATION_CONTRACT": "scientific evaluation contract",
        "SPONSORSHIP": "sponsorship",
        "TRAINING": "training"
      },
      "package": {
        "planned": "Planned package",
        "actual": "Actual packages"
      },
      "mandatory": {
        "packages": "Mandatory packs",
        "contract_templates": "Mandatory contract templates",
        "attachments": "Mandatory attachments templates"
      },
      "contract_template": "Contract(s)'s template(s)",
      "attachments": "Attachment(s) template(s)",
      "is_publication_allowed": "To publish"
    },
    "is_enabled": {
      "title": "State",
      "enabled": "Enabled",
      "disabled": "Disabled"
    },
    "enable": "Enable",
    "disable": "Disable"
  },
  "convention": {
    "selected_entity": "conventions",
    "list_title": {
      "all": "Conventions",
      "enabled": "Actives conventions",
      "disabled": "Inactives conventions"
    },
    "title": {
      "create": "Create a convention",
      "edit": "Edit a convention"
    },
    "create": "Create a convention",
    "name": "Last name",
    "type": "Type",
    "advantages": "Benefits",
    "state": {
      "title": "State",
      "enabled": "Enabled",
      "disabled": "Disabled"
    },
    "tabs": {
      "enabled": "Active",
      "disabled": "Inactive"
    },
    "enable": "Enable",
    "disable": "Disable",
    "button": {
      "create": "Create",
      "edit": "Edit"
    },
    "inputs": {
      "type": {
        "NONE": "None",
        "RECURRING_PROFESSIONAL_MEETING_ONE_AND_HALF_TO_EIGHT_HOURS_2026": "Convention 2026/01 - Recurring or evening professional meetings - duration 1h30 to 8h",
        "WEEKEND_SEMINAR_2026": "Convention 2026/02 - Recurring professional and scientific events, weekend seminar",
        "ON_SITE_TRAINING_HALF_TO_TWO_DAYS_2026": "Convention 2026/03 - On-site practical training sessions - Duration 1/2 day to 2 days",
        "INDUSTRIAL_SITE_MEETING_ONE_TO_TWO_DAYS_2026": "Convention 2026/04 - Professional meetings organized on industrial site - Duration 1 day to 2 days",
        "STAFF_MEETING_2026": "Convention 2026/05 - Staff",
        "ON_SITE_TRAINING_HALF_TO_TWO_DAYS_2024": "Convention 2024/03 - Sessions de formations pratiques sur site - Durée 1/2 journée à 2 jours",
        "INDUSTRIAL_SITE_MEETING_ONE_TO_TWO_DAYS_2024": "Convention 2024/04 - Réunions à visée professionnelle organisée sur site industriel - Durée 1 journée à 2 jours",
        "RECURRING_PROFESSIONAL_MEETING_ONE_AND_HALF_TO_EIGHT_HOURS_2024": "Convention 2024/01 - Réunions professionnelles répétitives ou en soirée - durée 1h30 à 8h",
        "WEEKEND_SEMINAR_2024": "Convention 2024/02 - Manifestations professionnelles et scientifiques répétitives, séminaire de fin de semaine",
        "STAFF_MEETING_2024": "Convention 2024/05 - Staff",
        "STAFF_MEETING_2020": "Convention 2020 - Staff",
        "RECURRING_PROFESSIONAL_MEETING1_2020": "Convention 2020 - Réunions Professionnelles Répétitives 1",
        "RECURRING_PROFESSIONAL_MEETING2_2020": "Convention 2020 - Réunions Professionnelles Répétitives 2",
        "ON_SITE_TRAINING_HALF_TO_ONE_DAY1_2020": "Convention 2020 - Formation sur site 1",
        "ON_SITE_TRAINING_HALF_TO_ONE_DAY2_2020": "Convention 2020 - Formation sur site 2",
        "INDUSTRIAL_SITE_MEETING_ONE_DAY1_2020": "Convention 2020 - Réunions sur site industriel 1",
        "INDUSTRIAL_SITE_MEETING_ONE_DAY2_2020": "Convention 2020 - Réunions sur site industriel 2",
        "WEEKEND_SEMINAR_2020": "Convention 2020 - Séminaires de fin de semaine"
      },
      "is_manual_pack_allowed": "Manual pack creation allowed"
    }
  },
  "ticket": {
    "cta": {
      "create": "Create a ticket"
    }
  },
  "allocation": {
    "subtype": {
      "name": "Last name",
      "enabled": "Enabled",
      "disabled": "Disabled",
      "all": "all",
      "state": "State",
      "action": "Actions",
      "input": {
        "name": "Last name",
        "filter": "Select a state"
      },
      "product": {
        "create_title": "Create a product",
        "edit_title": "Edit a product",
        "enabled": "Product enabled",
        "disabled": "Product disabled",
        "create": "Create",
        "update": "Editer"
      },
      "therapeutic_area": {
        "create_title": "Create a therapeutic area",
        "edit_title": "Edit a therapeutic area",
        "enabled": "Therapeutic area enabled",
        "disabled": "Therapeutic area disabled",
        "create": "Create",
        "update": "Editer"
      },
      "sector": {
        "create_title": "Create a sector",
        "edit_title": "Edit a sector",
        "enabled": "Sector enabled",
        "disabled": "Sector disabled",
        "create": "Create",
        "update": "Editer"
      },
      "region": {
        "create_title": "Create a region",
        "edit_title": "Edit a region",
        "enabled": "Region enabled",
        "disabled": "Region disabled",
        "create": "Create",
        "update": "Editer"
      },
      "unit": {
        "create_title": "Create a unit",
        "edit_title": "Edit a unit",
        "enabled": "Unit enabled",
        "disabled": "Unit disabled",
        "create": "Create",
        "update": "Editer"
      },
      "network": {
        "create_title": "Create a network",
        "edit_title": "Edit a network",
        "enabled": "Network enabled",
        "disabled": "Network disabled",
        "create": "Create",
        "update": "Editer"
      },
      "uga": {
        "create_title": "Create a UGA",
        "edit_title": "Edit a UGA",
        "enabled": "UGA enabled",
        "disabled": "UGA disabled",
        "create": "Create",
        "update": "Editer"
      },
      "zone": {
        "create_title": "Create a zone",
        "edit_title": "Edit a zone",
        "enabled": "Zone enabled",
        "disabled": "Zone disabled",
        "create": "Create",
        "update": "Editer"
      },
      "identity": {
        "create_title": "Create an identity",
        "edit_title": "Edit an identity",
        "enabled": "Identity enabled",
        "disabled": "Identity disabled",
        "create": "Create",
        "update": "Editer"
      }
    }
  },
  "internal_signer": {
    "title": {
      "create": "Create an internal signer",
      "edit": "Edit an internal signer"
    },
    "inputs": {
      "firstname": "First name",
      "lastname": "Last name",
      "executive_role": "Function",
      "phone": "Phone",
      "email": "Email",
      "civility": "Civility",
      "staff_id": "Staff Id"
    },
    "popup_modal_delete": {
      "title": "Delete internal signer",
      "warning": "This action is irreversible. Are you sure you want to delete this data ?"
    },
    "cta": {
      "create": "Create",
      "edit": "Edit",
      "cancel": "Cancel"
    }
  },
  "contact": {
    "title": {
      "create": "Create a contact",
      "edit": "Edit a contact"
    },
    "name": "Last name",
    "create": "Create a Contact",
    "update": "Update a Contact",
    "abort_update": "Abort update",
    "response_success": "Success"
  },
  "user": {
    "tab": {
      "general_informations": "General information",
      "allocations": "Allocations"
    },
    "legends": {
      "personal_information": "personnal information",
      "validators": "Validators",
      "roles": "Roles"
    },
    "inputs": {
      "firstName": "First name",
      "lastName": "Last name",
      "email": "Email",
      "phone": "Phone number",
      "staff_id": "Staff id",
      "user_enabled": "User enabled",
      "user_disabled": "User disabled",
      "first_validators": "Validator 1",
      "second_validators": "Validator 2",
      "products": "Products",
      "sectors": "Sectors",
      "therapeuticAreas": "Therapeutic areas",
      "units": "Units",
      "regions": "Regions",
      "networks": "Networks",
      "ugas": "UGAS",
      "zones": "Zones",
      "identities": "Entities",
      "search": "Search",
      "add_all": "Add all",
      "remove_all": "Remove all"
    },
    "create": {
      "title": "Create an User"
    },
    "edit": {
      "title": "Edit an User",
      "front_roles": "User roles",
      "admin_roles": "Administrator roles",
      "roles": {
        "assigned": "Actual assigned roles",
        "modification": "Roles modifications",
        "label": "Roles",
        "placeholder": "Select a role to add"
      }
    },
    "enabled": {
      "true": "Enabled",
      "false": "Disabled"
    },
    "cta": {
      "create": "User create",
      "submit": "Submit",
      "save_configuration": "Save configuration"
    },
    "filter": {
      "placeholder": "Filter"
    },
    "response_success": "Success",
    "response_graphql_error": "An unexpected error occurred. Please try again later.",
    "response_common_error": {
      "firstName": "You must provide a value for the 'First Name' field.",
      "lastName": "You must provide a value for the 'Last Name' field.",
      "email": "You must provide a value for the 'Email' field."
    },
    "selected": "Selected"
  },
  "workflow": {
    "list_title": "Workflow available",
    "title": {
      "create": "Create a workflow",
      "edit": "Edit a workflow"
    },
    "create": "Create a workflow",
    "steps": "Steps",
    "steps_available": "Available steps",
    "step_number": "Step .{number}",
    "step_order": "Steps order",
    "event_type": "Event type",
    "description": "Description",
    "actions": "Actions",
    "name": "Last name",
    "button_create": "Create",
    "button_update": "Update",
    "cancel": "Cancel",
    "response_success": "Success",
    "message_error": {
      "no_name": "You must provide a name for the workflow",
      "no_steps": "You must provide a least one step for the workflow",
      "query_error": "An error occured while creating the workflow"
    }
  },
  "identity": {
    "title": {
      "create": "Create an identity",
      "edit": "Edit an identity"
    },
    "modal": {
      "title": "Identity modification",
      "description": "The modifications made will impact the users and existing events.",
      "confirm": "Do you wish to perform this action?"
    },
    "inputs": {
      "name": "Siege social",
      "company_form": "Company form",
      "capital": "Capital",
      "place_of_registration": "Place of registration",
      "rcs": "RCS",
      "gdpr_contact": "GDPR contact",
      "mail_gdpr_contact": "Mail GDPR contact",
      "address": "Address",
      "postal_code": "Postal code",
      "city": "City",
      "department": "Department",
      "country": "Country",
      "legal_notice": "Legal notice",
      "eps_login": "Login EPS",
      "eps_password": "Password EPS",
      "idahe_login": "Login IDAHE",
      "idahe_password": "Password IDAHE",
      "representative_name": "Representative",
      "representative_title": "Title of the representative",
      "no_urssaf_rate": "No URSSAF rate"
    },
    "logo": {
      "drag_and_drop_statement": "Drag and drop your logo here",
      "or_statement": "Or if you prefer",
      "cta_label": "Select a file from your device"
    },
    "enabled": "Enabled",
    "disabled": "Disabled",
    "validate": "Validate",
    "cancel": "Cancel",
    "response_success": "Success",
    "main_identity": "Main identity",
    "details": "Laboratory information",
    "avatar": "Avatar"
  },
  "contract_templates": {
    "create_page_title": "Create a contract template",
    "edit_page_title": "Edit a contract template",
    "create": "Create a contract template",
    "update": "Update a contract template",
    "back_from_create": "Back to contract templates management",
    "documents": {
      "title": "Contract template versions",
      "headers": {
        "version": "Version",
        "name": "File name",
        "date": "Date",
        "hour": "Time",
        "created_by": "Uploaded by",
        "filesize": "File size",
        "status": "Status"
      },
      "status": {
        "ACTIVE": "Active",
        "ARCHIVED": "Archived"
      }
    }
  },
  "settings": {
    "label": "Settings",
    "attendee_sources": {
      "title": "Attendee search sources",
      "default_source": "Default selected source",
      "ubaq_only": "Contact Ubaq to enable this connector"
    },
    "upsell": {
      "title": "Options settings",
      "UPSELL_ANS": {
        "title": "ANS"
      },
      "UPSELL_DQC": {
        "title": "Activate Analytics"
      },
      "UPSELL_NOTIFICATIONS_CENTER": {
        "title": "Advanced notifications"
      }
    },
    "watchdogs": {
      "HOSPITALITY": {
        "title": "Student hospitality",
        "description": "A student is not allowed to receive hospitality benefits: meals, dinner, lunch, overnight stay, snack, transport and registration."
      },
      "UNANNOUNCED": {
        "title": "Unannounced events",
        "description": "A health professional can be invited a maximum of two times per year for an Impromptu operation.",
        "inputs": {
          "UNANNOUNCED_OPERATIONS": {
            "label": "Please select the type(s) of operation(s) for which the alert will be visible:"
          }
        }
      },
      "TICKET_DEADLINE": {
        "title": "Ticket behind deadline",
        "description": "Inform the number of days remaining before the start of the event.",
        "inputs": {
          "TICKET_DEADLINE_DAYS": {
            "label": "Please enter the number of calendar days before the start of the event from which the alert will be visible for the authorization regimes. Minimum accepted number: 60, maximum accepted number: 200."
          },
          "TICKET_DEADLINE_WORK_DAYS": {
            "label": "Please enter the number of working days before the start of the event from which the alert will be visible for the declaration regimes. Minimum accepted number: 8, maximum accepted number: 200."
          }
        }
      },
      "ATTENDEE_ADDED_POST_SUBMISSION": {
        "title": "Add attendee post submission",
        "description": "An attendee was added to the ticket after the submission and management step."
      },
      "SIMPLE_EVENTS_BY_DECLARATION": {
        "title": "Number of simplified events linked to the simplified declaration",
        "description": "Indication of the number of linked events and the number of events planned to the simplified declaration"
      },
      "ATTENDEE_SPECIALTY_DIFFERENT_FROM_DECLARATION": {
        "title": "Different specialty from those announced in the simplified declaration",
        "description": "A PS invited to a simplified event has a different specialty from those present in the simplified declaration."
      },
      "SIGNED_CONTRACT": {
        "title": "Signed Contract for authorization",
        "description": "Missing signed contracts for attendees after the submission and management step."
      }
    },
    "permissions": {
      "title": "Permissions",
      "description": "Summary of permissions associated with the role",
      "initiator": "Initiator",
      "custom_permissions": "restricted initiator",
      "list": {
        "EDIT_INFORMATION": "Access to general information and attachments",
        "EDIT_ATTENDEES": "Access to planned attendees: list of attendees, search, manual entry, import list",
        "EDIT_PLANNED_ADVANTAGES": "Access to planned advantages: create pack, browse existing packs, assign pack",
        "EDIT_SIGNING_SHEET": "Access to attendance: assign presence status and billing and attendance sheet",
        "EDIT_CONTRACT_MANAGEMENT": "Access to contract generation",
        "EDIT_SIGNING": "Access to signing: send contracts for signing",
        "EDIT_ACTUAL_ADVANTAGES": "Access to participants/actual expenses: create pack, browse existing packs, assign pack, detailed allocation, import actual expenses, annex expenses and justifications"
      },
      "save": "Save changes"
    }
  },
  "signatures_settings": {
    "tabs": {
      "procedure": "Procedure",
      "security_code": "Security code",
      "automatic_reminders": "Automatic reminders",
      "workspace": "Workspace",
      "mail_models": "Mail models"
    },
    "automatic_reminders": {
      "update_success": "Reminders validated",
      "interval_in_days": {
        "title": "Frequency of follow-ups",
        "label": "Please select the frequency of follow-ups to apply to all of your tickets",
        "EVERY_DAY": "Every day",
        "EVERY_TWO_DAY": "Every two days",
        "EVERY_WEEK": "Every week",
        "EVERY_TWO_WEEK": "Every two weeks"
      },
      "max_occurrences": {
        "title": "Number of follow-ups",
        "label": "Please enter the number of automatic follow-ups to apply to all of your tickets"
      },
      "warning": {
        "title": "Reminders activation",
        "text": "The activation of reminders will not have retroactive effect."
      }
    },
    "workspace": {
      "update_success": "Workspace validated",
      "workspace_id": {
        "title": "Enter workspace ID",
        "placeholder": "Workspace ID"
      },
      "custom_experience_id": {
        "title": "Enter custom experience ID",
        "placeholder": "Custom experience ID"
      }
    },
    "security_code": {
      "update_success": "Authentication mode validated",
      "text": "Please select the authentication mode for your signing procedures",
      "mail": "Security code via email",
      "sms": "Security code via SMS",
      "none": "No authentication code",
      "warning": {
        "title": "Security code",
        "text": "Any mode change will not have retroactive effect."
      }
    },
    "mail_models": {
      "invite_email": "Invitation email",
      "reminder_email": "Reminder email",
      "update_success": "Mail models validated",
      "tags": "Insert Tags :",
      "object": {
        "title": "Object",
        "label": "Email Object"
      },
      "body": {
        "title": "Body",
        "label": "Email content"
      },
      "reminder_object": {
        "title": "Reminder Object",
        "label": "Reminder Email Object"
      },
      "reminder_body": {
        "title": "Reminder Body",
        "label": "Reminder Email content"
      }
    }
  },
  "declarations": {
    "title": "Simplified declarations",
    "create_declaration": "Create a simplified declaration",
    "create_declaration_title": "Simplified declarations",
    "edit_declaration_title": "Edit a simplified declaration",
    "breadcrumbs": {
      "informations": "General information",
      "themes": "Themes",
      "deposit": "Deposit",
      "attachments": "Attached files",
      "simple-events": "Simple events"
    },
    "update_success": "The declaration was successfully updated",
    "update_advantage": "Advantage update",
    "archived": "Archived",
    "canceled": "Canceled",
    "modal": {
      "trash": {
        "title": "Confirmation of deletion",
        "description": "Are you sure you want to delete this Simplified declaration :",
        "button": "Confirm deletion"
      }
    },
    "deposit": {
      "informations": "Deposit informations",
      "inputs": {
        "reference": {
          "label": "Reference",
          "placeholder": "Please provide the reference"
        },
        "url": {
          "label": "URL",
          "placeholder": "Please provide the URL"
        },
        "submission_date": "Submission date",
        "recommendation_date": "Recommendation reception date",
        "comment": {
          "label": "Comment",
          "placeholder": "Please provide the comment"
        },
        "status": {
          "label": "Status",
          "TO_SUBMIT": "Submission to send",
          "SUBMITTED": "Submission sent",
          "CANCELED": "Submission canceled"
        }
      },
      "cta": {
        "create": "Save",
        "edit": "Edit",
        "cancel": "Cancel"
      }
    },
    "status": {
      "CREATING": "Creating",
      "TO_EDIT": "To edit"
    },
    "workflow_step": {
      "FIRST_VALIDATION": "First validation",
      "SECOND_VALIDATION": "Second validation",
      "SENT": "Send",
      "ACCEPTED": "Accepted",
      "REFUSED": "Refused",
      "ACTIVATED": "Referenced"
    },
    "filter": {
      "all": "All"
    },
    "search": {
      "placeholder": "Search by name / code"
    },
    "upsert": {
      "inputs": {
        "legends": {
          "identification": "Identification",
          "attendees": "Attendees",
          "validations": "Validations",
          "details": "Details",
          "coordinates": "Address",
          "connectors": "Connectors"
        },
        "attendee_quantity": "Average number of attendees (per event)",
        "declaration_count": "Number of events",
        "name": "Name of the simplified declaration",
        "number": "Number of events",
        "date_range": "Start and end date of the covered period",
        "city": "City",
        "country": "Country",
        "in_convention": "Convention advantages",
        "in_declaration": "Simplified declaration advantages",
        "advantage": {
          "label": "Advantage {status}",
          "disabled": "disabled",
          "enabled": "enabled"
        },
        "convention_id": "Convention type",
        "workflow": "Workflow type",
        "initiator": "Initiator",
        "validator_1": "Validator 1",
        "validator_2": "Validator 2",
        "reference": "Administrative reference",
        "external_code": "External code",
        "specialties": {
          "label": "IDAHE specialty(s)",
          "ALLERGOLOGY": "Allergology",
          "ANATOMICAL_PATHOLOGY": "Anatomical pathology",
          "ANGIOLOGY": "Angiology",
          "MEDICAL_BIOLOGY": "Medical biology",
          "CARDIOLOGY": "Cardiology",
          "MAXILOFACIAL_SURG": "Maxilofacial surg.",
          "CARDIOVASCULAR_SURG": "Cardiovascular surg.",
          "VISCERAL_SURG": "Visceral surg.",
          "SURGERY": "Surgery",
          "FACE_SURG": "Face and neck surgery",
          "INFANT_SURG": "Infant surgery",
          "ORTHOPEDIC_SURG": "Orthopedic surgery",
          "PLASTIC_SURG": "Plastic surgery",
          "UROLOLOGIC_SURG": "Urologic surg.",
          "VASCULAR_SURG": "Vascular surg.",
          "DERMATOLOGY": "Dermatology",
          "PROFESSIONAL_DVPT": "Professional development",
          "ENDOCRINOLOGY": "Endocrinology",
          "GASTROENTEROLOGY": "Gastroenterology",
          "GENETICS": "Genetics",
          "GERIATRICS": "Geriatrics",
          "MEDICAL_GYNECOLOGY": "Medical gynecology",
          "OBSTETRIC_GYNECOLOGY": "Obstetric gynecology",
          "HEMATOLOGY": "Hematology",
          "INFECTIOLOGY": "Infectiology",
          "READAPT_MEDICINE": "Readaptation medicine",
          "EMERGENCY_MEDICINE": "Emergency medicine",
          "SPORT_MEDICINE": "Sport medicine",
          "WORK_MEDICINE": "Work medicine",
          "GENERAL_MEDICINE": "General medicine",
          "INTERN_MEDICINE": "Intern medicine",
          "NUCLEAR_MEDICINE": "Nuclear medicine",
          "THERMAL_MEDICINE": "Thermal medicine",
          "MULTIDISCIPLINARY": "Multidisciplinary",
          "NEPHROLOGY": "Nephrology",
          "NEUROSURGERY": "Neurosurgery",
          "NEUROLOGY": "Neurology",
          "ONCOLOGY": "Oncology",
          "OPHTALMOLOGY": "Ophtalmology",
          "ORL": "ORL",
          "PEDIATRICS": "Pediatrics",
          "PHARMACOLOGY": "Pharmacology",
          "PNEUMOLOGY": "Pneumology",
          "PSYCHIATRY": "Psychiatry",
          "MEDICAL_IMAGERY": "Medical imagery",
          "RADIOLOGY": "Radiology",
          "ANESTHESIA": "Anesthesia",
          "MEDICAL_RESEARCH": "Medical research",
          "RHEUMATOLOGY": "Rhumatology",
          "PUBLIC_HEALTH": "Public health",
          "STOMATOLOGY": "Stomatology",
          "LOCAL_TRAINING_ORG": "Local training org.",
          "TRANSPLANT": "Transplant"
        },
        "manager_crm": "CRM manager"
      },
      "table": {
        "name": "Last name",
        "convention_id": "Convention type",
        "theme": "Theme",
        "start_at": "Start at",
        "reference": "Reference",
        "created_at": "Created at",
        "created_by": "Created by",
        "status": "Status",
        "nb_tickets": "Tickets count/planned number"
      },
      "buttons": {
        "submit": {
          "validate": "Save and validate",
          "send_to_validation": "Save and send to validation"
        },
        "send_back_to_initiator": "Send back to initiator for edit",
        "reference": "Reference",
        "accept": "Accept",
        "reject": "Reject"
      }
    },
    "themes": {
      "inputs": {
        "name": "Name",
        "duration": "Duration"
      },
      "placeholder": {
        "duration": "Use HH:MM format"
      },
      "name": "Name",
      "duration_per_hour": "Duration (hours)"
    },
    "attachments": {
      "drag_and_drop_statement": "Select a file or drag and drop it here",
      "inputs": {
        "type": "File type",
        "comment": "Comment",
        "upload": "Upload your file"
      }
    },
    "advantages": {
      "total_error": "Advantages can't be bigger than those from the convention"
    },
    "simple-events": {
      "title": "List of linked events",
      "search_placeholder": "Search by event name",
      "table": {
        "code": "Code",
        "workflow_step": "Workflow step",
        "name": "Name",
        "start_at": "Start at",
        "end_at": "End at",
        "present_doctors_count": "Present doctors count",
        "doctor_list_status": "List status"
      },
      "doctor_list_status": {
        "PENDING": "Pending submission",
        "SENT": "Submitted",
        "CANCELED": "Canceled"
      },
      "floatBar": {
        "assign_to_events": "Assign to linked events"
      },
      "doctor_list_export": "Doctors list"
    }
  },
  "attachment_template": {
    "create": {
      "title": "Create an Attachment template"
    },
    "cta": {
      "create": "Create an attachment",
      "add": "Add",
      "cancel": "Cancel"
    }
  },
  "specialties": {
    "name": "Last name",
    "technical_key": "Technical key",
    "action": "Actions",
    "create": "Create a specialty",
    "edit": "Edit a specialty",
    "alert": {
      "edit": "Editing this specialty will affect all your guests and contacts associated with this specialty."
    },
    "button": {
      "create": "Create",
      "update": "Edit"
    },
    "input": {
      "name": "Last name",
      "technical_key": "Technical key"
    }
  },
  "crm_user": {
    "popup_modal_delete": {
      "title": "Delete a CRM user",
      "warning": "This action is irreversible. Are you sure you want to delete this CRM user ?"
    },
    "title": {
      "table_title": "CRM user",
      "create": "Create an user CRM",
      "edit": "Edit an user CRM"
    },
    "search": {
      "placeholder": "Search a CRM user"
    },
    "inputs": {
      "lastname": "Last name",
      "firstname": "First name",
      "email": "Email",
      "responsibilities": "Roles",
      "post_title": "Function",
      "staff_id": "Staff Id"
    },
    "responsibility": {
      "APPROVER": "Approver CRM",
      "MANAGER": "Manager CRM"
    }
  },
  "notifications": {
    "filters": {
      "type": {
        "all": "All",
        "enabled": "Enabled",
        "disabled": "Disabled",
        "placeholder": "Notification type"
      }
    },
    "input": {
      "name": {
        "label": "Last name",
        "placeholder": "Notification name"
      },
      "type": "Notification type",
      "operation": "Operation type",
      "event_types": {
        "label": "Event type",
        "CONTRACT": "Contract",
        "EVENT": "Declared event",
        "DONATION": "Donation",
        "SIMPLE_EVENT": "Simplified event",
        "UNDECLARED_EVENT": "Undeclared event"
      },
      "target_state": {
        "label": "State arrival",
        "CREATING": "Creating",
        "FIRST_VALIDATION": "First validation",
        "SECOND_VALIDATION": "Second validation",
        "TO_EDIT": "To edit",
        "CONTRACT_MANAGEMENT": "In submission & management",
        "EVENT_IN_PROGRESS": "Event in progress",
        "EVENT_VALIDATING": "Validation expenses",
        "EVENT_IS_FINISHED": "Event finished",
        "IS_DECLARED": "Declared",
        "IS_ARCHIVED": "Archived",
        "IS_PUBLISHED": "Published",
        "CANCELED": "Canceled"
      },
      "legends": {
        "main": "Notification",
        "identifications": "Identification",
        "criteria": "Criteria",
        "recipients": "Recipients",
        "recipients_message": "(Select at least 1 recipient)",
        "details": "Details"
      },
      "submission_regime": {
        "label": "Regime",
        "DECLARATION": "Declaration",
        "AUTHORIZATION": "Authorization",
        "ALL": "All"
      },
      "period": {
        "label": "Period",
        "BEFORE": "Before",
        "AFTER": "After"
      },
      "delay": {
        "5": "5",
        "10": "10",
        "20": "20",
        "30": "30",
        "label": "Delay in days"
      },
      "date_boundary": {
        "label": "Reference date",
        "START_AT": "Start date",
        "END_AT": "End date"
      },
      "day_type": {
        "label": "Day type",
        "WORKING": "Working days",
        "BUSINESS": "Business days",
        "CALENDAR": "Calendar days"
      },
      "types": {
        "DELAY_ALERT": "Delay alert",
        "CHANGING_STATE": "Changing state"
      },
      "internal_emails": "Internal emails",
      "external_emails": {
        "label": "External emails",
        "placeholder": "Enter one or more email addresses"
      },
      "ticket_roles_to_notify": "User(s) attached to the ticket by role",
      "email_object": {
        "label": "Email object",
        "placeholder": "Enter the email object"
      },
      "email_body": {
        "label": "Email body",
        "placeholder": "Enter the email body"
      },
      "comment": {
        "label": "Comment",
        "placeholder": "Enter a comment"
      }
    },
    "create": "Create",
    "cancel": "Cancel",
    "update": "Update",
    "table": {
      "title": "Notifications",
      "cta": "Create a notification",
      "select": {
        "placeholder": "notification",
        "enabled": "Enabled",
        "to_enable": "Enabling",
        "disabled": "Disabled",
        "to_disable": "Disabling"
      }
    },
    "meta": {
      "notification": "Notification settings",
      "create": "Create a notification",
      "update": "Update the notification"
    },
    "email_body": {
      "default": "Hello,\n\nThe event {'{'}ticket_code{'}'} has reached the \"{'{'}target_state{'}'}\" state.\nYou can now log in to handle the event.\n\n{'{'}ticket_link{'}'}.",
      "changing_state": {
        "canceled": "Hello,\n\nThe event {'{'}ticket_code{'}'} has reached the \"{'{'}step{'}'}\" state.\n\n{'{'}ticket_link{'}'}."
      },
      "delay_alert": {
        "day_type": {
          "WORKING": "working days",
          "BUSINESS": "business days",
          "CALENDAR": "calendar days"
        },
        "start_at": {
          "authorization": "Hello,\n\nThe event {ticket_code} in the Authorization or Mixed regime will start in {delay_by_days} {type_of_days}.\n\nYou can now connect to handle the event.\n\n{'{'}ticket_link{'}'}\n\nBest regards,",
          "declaration": "Hello,\n\nThe event {ticket_code} in the Declaration regime will start in {delay_by_days} {type_of_days}.\n\nYou can now connect to handle the event.\n\n{'{'}ticket_link{'}'}\n\nBest regards,",
          "all": "Hello,\n\nThe event {ticket_code} will start in {delay_by_days} {type_of_days}.\n\nYou can now connect to handle the event.\n\n{'{'}ticket_link{'}'}\n\nBest regards,"
        },
        "end_at": {
          "authorization": "Hello,\n\nThe event {'{'}ticket_code{'}'} in the Authorization or Mixed regime has been running for {'{'}delay_days{'}'} {'{'}day_type{'}'}.\n\n{'{'}ticket_link{'}'}\n\nBest regards,",
          "declaration": "Hello,\n\nThe event {'{'}ticket_code{'}'} in the Declaration regime has been running for {'{'}delay_days{'}'} {'{'}day_type{'}'}.\n\n{'{'}ticket_link{'}'}\n\nBest regards,",
          "all": "Hello,\n\nThe event {'{'}ticket_code{'}'} has been running for {'{'}delay_days{'}'} {'{'}day_type{'}'}.\n\n{'{'}ticket_link{'}'}\n\nBest regards,"
        }
      }
    }
  },
  "event_state_badge": {
    "creating": "Creating",
    "to_edit": "To edit",
    "is_canceled": "Canceled",
    "is_archived": "Archived",
    "is_published": "Published",
    "is_declared": "Declared",
    "first_validation": "First validation",
    "second_validation": "Second validation",
    "contract_management": "In submission & management",
    "event_in_progress": "Event in progress",
    "event_validating": "Validation expenses",
    "event_is_finished": "Event finished"
  }
}
